import React from 'react'

const Footer = () => <h1>Footer Here</h1>

export default Footer
